export const API_BASE = `https://spectory.at/architektur-schoen/wp-json/siegfried/v1`;

export const FACEBOOK_PIXEL_ID = '';
export const GOOGLE_ANALYTICS_KEY = '';
export const GOOGLE_TAG_MANAGER_KEY = 'GTM-KQCFWHN';
export const LINKEDIN_PIXEL_ID = '';
export const LINKEDIN_CONVERSION_ID = '';
export const HOTJAR_KEY = '';